import axios from "../helper/AxiosHelper";
import ApiHelper from "./ApiHelper";

// DashboardModel
const getOrganizationList = async () => {
  const response = await axios.get("/admin/wallDashboard/getOrganizationList");

  return ApiHelper.processResponse(response);
}

const getDashboardData = async () => {
  const url = `/admin/getDashboardData`;

  const response = await axios.get(url);

  return ApiHelper.processResponse(response);
}

const getSkillNameMapping = async () => {
  const url = `/skillInfo?fields=raw`;

  const response = await axios.get(url);
  // console.debug("getSkillNameMapping response", response);

  const result = ApiHelper.processResponse(response);


  if (result == null || result == undefined) {
    console.debug("No skill name mapping found");
    return;
  }

  // Check if the result is an array or an object
  if (!Array.isArray(result)) {
    console.debug("Skill name mapping is not an array");
    return;
  }
  // Convert the array to a map for easier access
  const skillNameMap = {};
  result.forEach(item => {
    skillNameMap[item.code] = item.name_zh || item.name_en || item.code; // Fallback to code if name not available
  });

  console.debug("skillNameMap: ", skillNameMap);

  return skillNameMap;
}


const getLatestPlayActivity = async (since) => {
  const url = `/admin/wallDashboard/getLatestPlayActivity?since=${since}`;

  const response = await axios.get(url);

  return ApiHelper.processResponse(response);

}

const getDashboardVideoList = async () => {
  const url = `/dashboardVideo`;

  const response = await axios.get(url);

  return ApiHelper.processResponse(response);
}



export const DashboardApi = {
  getOrganizationList,
  getLatestPlayActivity,
  getDashboardData,
  getSkillNameMapping,
  getDashboardVideoList,
};
